import { connect } from "react-redux";
import { Dispatch } from "redux";
import IAppState from "../../redux/types/IAppState";
import { ScheduledJobsPage } from "./ScheduledJobsPage"; 
import { deleteScheduledJobAsync, getAllScheduledJob, upsertScheduledJobAsync } from "../../redux/thunks/HomeThunks";
import { getRepertoireComponentDataThunk } from "../../redux/thunks/RepertoireThunks";
import { hideModal, showModal, showWorkSubmission, showYesNoPrompt } from "../../redux/reducers/ModalReducer";
import { IYesNoPromptViewModalProps } from "../../repertoire/components/modalViews/yesNoPromptView/YesNoPromptView";
import { ISubmissionPromptViewModalProps } from "../../repertoire/components/modalViews/workSubmission/WorkSubmission";


export default connect(
    (state: IAppState, props?: any) => ({
        lookupValues: state.lookupEntities,
        scheduledJobs: state.home.allScheduledJobs,
        dataGridTableData: state.repertoire.componentData.DataGridTable,
        displayModal: state.modal.displayModal,
        customerTimeZone: state.account.customerTimeZone,
  }),
  (dispatch: Dispatch) => ({
    getAllScheduledJob: () =>
                dispatch<any>(getAllScheduledJob()),
    getRepertoireFields: () => dispatch<any>(getRepertoireComponentDataThunk()),
    showModal: (modalContent: string, modalComponentInstance: string, modalProps: any, displayModalCloseButton: boolean, title: string) => 
      dispatch<any>(showModal(modalContent, modalComponentInstance, modalProps, displayModalCloseButton, title)),
    upsertScheduledJobAsync: (scheduledJob: any) => dispatch<any>(upsertScheduledJobAsync(scheduledJob)),
    deleteScheduledJobAsync: (scheduledJob: any) => dispatch<any>(deleteScheduledJobAsync(scheduledJob)),
    hideModal: () => dispatch(hideModal()),
    showYesNoPrompt: (title: string, props: IYesNoPromptViewModalProps, message?: string, detailMessage?: string) =>
                        dispatch(showYesNoPrompt(title, props, message, detailMessage)),
     showJSONCodeInCopyModal: (submission: string, props: ISubmissionPromptViewModalProps) =>
                dispatch<any>(showWorkSubmission(submission, props)),
  })
)(ScheduledJobsPage);